import styled from 'styled-components';

import { Skeleton } from '~/src/common/components/Skeleton/Skeleton';
import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/deprecated';
import { RecipeGridArea } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/layout';

import { Grid as OriginalGrid } from '../../layout';
export { Root, Content } from '../../layout';

export const NameAndTag = styled.div`
  grid-area: ${RecipeGridArea.NameAndTags};
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Image = styled(Skeleton)`
  grid-area: ${RecipeGridArea.Image};
  margin: auto;
  max-width: 359px;
  max-height: 359px;
`;

export const Picker = styled.div`
  grid-area: ${RecipeGridArea.AddToCart};
  display: none;

  ${media.M`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-top: 1px solid ${COLORS.NEUTRAL_STROKE};
    border-bottom: 1px solid ${COLORS.NEUTRAL_STROKE};
    padding: 16px 8px;
  `}
`;

export const PreparationInfos = styled.div`
  grid-area: ${RecipeGridArea.PreparationInfos};
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

export const ShortDescription = styled.div`
  grid-area: ${RecipeGridArea.ShortDescription};
  display: flex;
  flex-direction: column;
  gap: 8px;

  div:last-child {
    align-self: flex-end;
  }
`;

export const ProductInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AdditionalInformation = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Grid = styled(OriginalGrid)`
  &:has(${ShortDescription}) {
    grid-template-areas:
      '${RecipeGridArea.NameAndTags}'
      '${RecipeGridArea.Image}'
      '${RecipeGridArea.PreparationInfos}'
      '${RecipeGridArea.ShortDescription}';
  }

  ${media.M`
    &:has(${ShortDescription}) {
      grid-template-areas:
      '${RecipeGridArea.Image} ${RecipeGridArea.NameAndTags}'
      '${RecipeGridArea.Image} ${RecipeGridArea.AddToCart}'
      '${RecipeGridArea.Image} ${RecipeGridArea.PreparationInfos}'
      '${RecipeGridArea.Image} ${RecipeGridArea.ShortDescription}'
    }
  `}
`;
